import A60 from "../images/projects/A60.png";
import A61 from "../images/projects/A61.png";
import A62 from "../images/projects/A62.jpg";
import A63 from "../images/projects/A63.jpeg";
import A64 from "../images/projects/A64.jpg";
import A65 from "../images/projects/A65.png";
import A66 from "../images/projects/Librehealth.png";



export const experiencesData = [
    {
        id: "georgiastate",
        title: "Graduate Teaching Assistant",
        category: "Graduate Teaching Assistant",
        img: A65,
    },
    {
      id: "basketofinance",
      title: "Software Development Engineer",
      category: "Full-Time",
      img: A60,
    },
    {
      id: "capgemini",
      title: "Software Engineer Intern",
      category: "Internship",
      img: A62,
    },
    {
      id: "librehealth",
      title: "Software Engineer Intern - Part-time",
      category: "Open-Source Contribution",
      img: A66,
  },
    {
      id: "gerent",
      title: "Salesforce Developer",
      category: "Part-time",
      img: A61,
    },

    {
      id: "tesseract",
      title: "Cyber Security Specialist",
      category: "Internship",
      img: A63,
    },
    {
      id: "lockhaven",
      title: "Data Scientist Intern",
      category: "Internship",
      img: A64,
    },
  ];
  
  export default experiencesData;
    